import { ErrorHandler, inject, Injectable, NgZone } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import * as Sentry from "@sentry/angular-ivy";
import { DialogsService } from "../../../shared/services/dialogs/dialogs.service";
import { ConfirmationDialogComponent } from "../../../shared/components/confirmation-dialog/confirmation-dialog.component";

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  private zone = inject(NgZone);
  private dialogsService = inject(DialogsService);

  private alreadyPrompted = false;

  constructor() {
    super();
  }

  handleError(error: any): void {
    if (error.name === "EmptyError") {
      return;
    }
    if (this.isChunkLoadError(error)) {
      if (this.alreadyPrompted) return;
      this.zone.run(() => {
        this.alreadyPrompted = true;
        const ref = this.dialogsService.open(
          ConfirmationDialogComponent,
          "fit-content",
          "fit-content",
          {
            title: "Mise à jour de l'application",
            message:
              "Une nouvelle version de l'application est en ligne. Merci de bien vouloir rafraîchir la page.",
          },
        );
        ref.afterClosed().subscribe((v) => {
          this.alreadyPrompted = false;
          if (!v) return;
          const key = "chunk_reload_attempted";
          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, "1");
            location.reload();
          } else {
            location.href = "/";
          }
        });
        return;
      });
    }

    super.handleError(error);

    // Ne pas envoyer les erreurs HTTP à Sentry — gérées par l'interceptor
    if (error instanceof HttpErrorResponse) return;
    const inner = error?.rejection ?? error;
    if (inner?.status && inner?.headers) return;

    Sentry.captureException(error);
  }

  isChunkLoadError(err: any): boolean {
    const msg = (err?.message || err?.toString?.() || "").toLowerCase();
    return (
      msg.includes("loading chunk") ||
      msg.includes("chunkloaderror") ||
      (msg.includes("import()") && msg.includes("failed"))
    );
  }
}
